import { forwardRef, Ref, useRef, useEffect, ReactNode } from 'react';
import { Marker } from 'react-leaflet';
import * as L from 'leaflet';
import 'leaflet-rotatedmarker';

interface MarkerProps {
  children?: ReactNode;
  rotationAngle: number;
  rotationOrigin: string;
  icon: any;
  position: any;
  onClick: () => void;
}

const RotatedMarker = forwardRef<Ref<any>, MarkerProps>(
  (props, forwardRef: any) => {
    const markerRef: any = useRef();

    const { rotationAngle, rotationOrigin } = props;
    useEffect(() => {
      if (markerRef.current == null) {
        return;
      }

      const marker: L.Marker = markerRef.current;

      if (rotationAngle && rotationOrigin) {
        marker.setRotationAngle(rotationAngle ?? 0);
        marker.setRotationOrigin(rotationOrigin ?? 'center');
      }
    }, [rotationAngle, rotationOrigin]);

    return (
      <Marker
        eventHandlers={{
          click: () => {
            props.onClick();
          },
        }}
        ref={(ref) => {
          markerRef.current = ref as L.Marker<any>;
          if (forwardRef) {
            forwardRef.current = ref;
          }
        }}
        {...props}
      >
        {props.children}
      </Marker>
    );
  }
);

export default RotatedMarker;
